import { render, staticRenderFns } from "./产权需求详情_自由竞价版本_socket.vue?vue&type=template&id=eced7654&scoped=true"
import script from "./产权需求详情_自由竞价版本_socket.vue?vue&type=script&lang=js"
export * from "./产权需求详情_自由竞价版本_socket.vue?vue&type=script&lang=js"
import style0 from "./产权需求详情_自由竞价版本_socket.vue?vue&type=style&index=0&id=eced7654&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eced7654",
  null
  
)

export default component.exports